<template lang="html">
  <div id="ModifyDialog">
    <vs-popup class="holamundo" title="프로젝트 정보 수정" :active.sync="dialogVisible">
      <el-row>
        <el-col :span="20" :offset="2">
          <vs-input label-placeholder="프로젝트 이름(최소 2글자, 최대 20글자)" v-model="projectInfo.name" style="width: 100%;" autofocus />
          <vs-textarea counter="200" label="프로젝트 설명" :counter-danger.sync="counterDanger" v-model="projectInfo.desc" style="margin-top: 12px;" />
          <vs-input label-placeholder="프로젝트 비밀번호(영문 또는 숫자, 최소 4글자)" v-model="projectInfo.pw" type="password" style="width: 100%; margin-top: 24px;" />
          <vs-input label-placeholder="프로젝트 비밀번호 확인" v-model="checkPw" type="password" style="width: 100%; margin-top: 24px;" v-if="projectInfo.pw !== originProjectInfo.pw" />
        </el-col>
      </el-row>
      <el-row style="margin: 24px 8px;">
        <hr style="color: var(--gray-color)">
      </el-row>
      <el-row :span="24" class="gm-layout-horizontal" style="margin-top: 12px;">
        <el-button size="small" @click="cancel" style="width: 80px; margin-left: auto; margin-right: 8px;">취소</el-button>
        <el-button size="small" type="primary" style="width: 80px; margin-right: 8px;" @click="complete" :disabled="!isChanged">수정</el-button>
      </el-row>
    </vs-popup>
  </div>
</template>
<script>
import { db } from '@/firebase'
export default {
  name: 'ModifyDialog',
  props: {},
  components: {},
  data: () => ({
    dialogVisible: false,
    counterDanger: false,
    checkPw: '',
    projectInfo: {},
    originProjectInfo: {},
    isChanged: false
  }),
  methods: {
    complete() {
      this.$vs.loading()
      var uid = this.$route.params.uid
      var pid = this.$route.params.pid
      var creatable = false
      var title = null
      var text = null
      // Check data validation
      if (this.projectInfo.name.length === 0) {
        title = '프로젝트 이름이 없네요!'
        text = '프로젝트 이름을 입력해주세요.'
      } else if (this.projectInfo.name.length < 2) {
        title = '프로젝트 이름이 너무 짧아요!'
        text = '프로젝트 이름을 최소 2글자 이상 적어주세요.'
      } else if (this.projectInfo.name.length > 20) {
        title = '프로젝트 이름이 너무 길어요!'
        text = '프로젝트 이름을 20글자 이하로 적어주세요.'
      } else if (this.projectInfo.desc.length > 200) {
        title = '프로젝트 설명이 너무 길어요!'
        text = '프로젝트 설명을 200자 이내로 적어주세요.'
      } else if (this.projectInfo.desc.length === 0) {
        title = '프로젝트 설명을 적어주세요!'
        text = '프로젝트 설명이 필요해요.'
      } else if (this.projectInfo.pw.length < 4 && this.projectInfo.pw.length > 0) {
        title = '비밀번호가 너무 짧아요!'
        text = '비밀번호는 최소 4글자 이상 적어주세요.'
      } else if (this.projectInfo.pw.length === 0) {
        title = '비밀번호를 입력해주세요!'
        text = '비밀번호는 프로젝트 접근시 사용되요.'
      } else if (!/^[a-zA-Z0-9+]*$/.test(this.projectInfo.pw)) {
        title = '비밀번호의 형식이 올바르지않아요!'
        text = '비밀번호는 영문 또는 숫자만 가능해요.'
      } else if (this.projectInfo.pw !== this.checkPw) {
        title = '비밀번호가 일치하지 않아요!'
        text = '비밀번호를 확인해주세요.'
      } else {
        creatable = true
      }

      if (!creatable) {
        setTimeout(_ => { this.$vs.loading.close() }, 1)
        this.$vs.notify({
          title: title,
          text: text,
          color: 'warning',
          icon: 'error',
          time: 3000,
          position: 'top-center'
        })
      } else {
        const projectDB = db.collection('users').doc(uid).collection('projects').doc(pid)
        projectDB.collection('info').doc('project').update(this.projectInfo).then(_ => {
          // Project updated
          this.$log.d('project updated')
          this.originProjectInfo = this.projectInfo
          this.dialogVisible = false
          this.$vs.notify({
            title: '프로젝트 정보 업데이트 완료',
            text: '프로젝트 정보를 수정하였어요.',
            color: 'success',
            icon: 'done',
            time: 3000,
            position: 'top-center'
          })
          this.$vs.loading.close()
        }).catch(err => {
          this.$log.w('err occured', err)
          this.$vs.notify({
            title: '프로젝트 정보 업데이트 실패',
            text: err,
            color: 'danger',
            icon: 'done',
            time: 3000,
            position: 'top-center'
          })
          this.$vs.loading.close()
        })
      }
    },
    cancel() {
      this.dialogVisible = false
    }
  },
  beforeUpdate() {
    var isChanged = false
    for (var key in this.projectInfo) {
      if (key === 'createdAt') continue
      if (this.projectInfo[key] !== this.originProjectInfo[key]) {
        isChanged = true
        break
      }
    }
    this.isChanged = isChanged
  },
  mounted() {
    this.$event.$on(this.$eventList.showModifyDialog, (isShow, projectInfo) => {
      this.dialogVisible = isShow
      this.projectInfo = JSON.parse(JSON.stringify(projectInfo))
      this.originProjectInfo = JSON.parse(JSON.stringify(projectInfo))
      this.projectInfo.createdAt = projectInfo.createdAt // json 파싱하면 object가 되므로 timestamp로 변경
      this.checkPw = this.projectInfo.pw
    })
  },
  beforeDestroy() {
    this.$event.$off([
      this.$eventList.showModifyDialog
    ])
  }
}

</script>
<style lang="scss" scoped>
#ModifyDialog {}

.select-wrapper {
  display: flex;
  margin: 16px;
}

.vs-popup {
  z-index: 2001;
}

</style>



// WEBPACK FOOTER //
// src/components/Project/Sidebar/ModifyDialog/index.vue